import React from "react";
import useInView from "@/hooks/useInView";

const AnimatedSection = ({ children, className = "", delay = 0 }) => {
  const [ref, isInView] = useInView(0.1);
  
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${className}`}
      style={{
        opacity: isInView ? 1 : 0,
        transform: isInView ? "translateY(0)" : "translateY(40px)",
        transitionDelay: `${delay}ms`
      }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;
